var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Vue, Component, Model, Watch } from "vue-facing-decorator";
import moment from "moment";
let MonthYearPickerVue = class MonthYearPickerVue extends Vue {
    constructor() {
        super(...arguments);
        this.selectedMonthOption = null;
        this.customDate = null;
        this.isUpdating = false;
    }
    get monthOptions() {
        const options = [];
        for (let i = 0; i < 12; i++) {
            const date = moment().subtract(i, "months");
            options.push({
                value: date.format("YYYY-MM"),
                text: date.format("MMM YYYY")
            });
        }
        options.push({ value: "custom", text: "Custom..." });
        return options;
    }
    get isCustom() {
        var _a;
        return ((_a = this.selectedMonthOption) === null || _a === void 0 ? void 0 : _a.value) === "custom";
    }
    get flatPickrConfig() {
        return {
            dateFormat: "Y-m",
            altFormat: "F Y",
            altInput: true,
            enableTime: false,
            allowInput: true,
            maxDate: moment().endOf("month").format("YYYY-MM-DD"),
            defaultDate: this.customDate ? moment(this.customDate).format("YYYY-MM") : null,
            onChange: (selectedDates) => {
                if (selectedDates && selectedDates[0]) {
                    const d = selectedDates[0];
                    d.setDate(1);
                    const now = new Date();
                    if (d > now) {
                        this.$nextTick(() => {
                            this.customDate = null;
                        });
                        alert("You cannot select a future month.");
                        return;
                    }
                }
            }
        };
    }
    created() {
        this.updateSelectionFromModel(this.periodValue);
    }
    onSelectedMonthOptionChanged(option) {
        if (!option || this.isUpdating)
            return;
        if (option.value === "custom") {
            this.updatePeriodValue(this.customDate);
        }
        else {
            const date = moment(option.value, "YYYY-MM").toDate();
            this.updatePeriodValue(date);
        }
    }
    onCustomDateChanged(newDate) {
        if (this.isUpdating || !this.isCustom)
            return;
        this.updatePeriodValue(newDate);
    }
    updateSelectionFromModel(val) {
        var _a, _b;
        this.isUpdating = true;
        try {
            if (!val) {
                this.selectedMonthOption = (_a = this.monthOptions[0]) !== null && _a !== void 0 ? _a : null;
                this.customDate = null;
                return;
            }
            const formatted = moment(val).format("YYYY-MM");
            const found = this.monthOptions.find(opt => opt.value === formatted);
            if (found) {
                this.selectedMonthOption = found;
                this.customDate = null;
            }
            else {
                this.selectedMonthOption = (_b = this.monthOptions.find(opt => opt.value === "custom")) !== null && _b !== void 0 ? _b : null;
                this.customDate = val;
            }
        }
        finally {
            this.$nextTick(() => {
                this.isUpdating = false;
            });
        }
    }
    updatePeriodValue(date) {
        if (this.isUpdating)
            return;
        this.isUpdating = true;
        try {
            this.periodValue = date;
        }
        finally {
            this.$nextTick(() => {
                this.isUpdating = false;
            });
        }
    }
};
__decorate([
    Model(),
    __metadata("design:type", Object)
], MonthYearPickerVue.prototype, "periodValue", void 0);
__decorate([
    Watch("selectedMonthOption"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MonthYearPickerVue.prototype, "onSelectedMonthOptionChanged", null);
__decorate([
    Watch("customDate"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MonthYearPickerVue.prototype, "onCustomDateChanged", null);
MonthYearPickerVue = __decorate([
    Component({
        name: "MonthYearPickerVue"
    })
], MonthYearPickerVue);
export default MonthYearPickerVue;
